import type { CSSProperties } from 'react';

import type { ILoaderProps } from './types';

import style from './styles.module.scss';

const Loader = ({ size = 60, color = '#fff', speed = 1 }: ILoaderProps) => {
  const loaderStyle = {
    width: size,
    height: size,
    color,
    ['--loader-speed' as string]: `${speed}s`,
  } as CSSProperties;

  return (
    <div
      className={style.loader}
      style={loaderStyle}
    ></div>
  );
};

export default Loader;
